export const Embed = ({ width, rows, cols, owners, layout, query, language }) => {
    const code = `<script src="https://widgets.dimu.org/static/js/bootstrap.js?2.0.0"></script>\n` +
        `<script type="text/javascript">renderwidget("https://widgets.dimu.org/",${width},${rows},${cols},"${owners}","","${layout}","${query}","${language}");</script>\n` +
        `<noscript><p>You need to enable JavaScript to run this app.</p></noscript>`;

    return <textarea value={code} readonly={true} />
};
